module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAMAAADzjKfhAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAJUExURf///0xpcf///0HUl50AAAACdFJOU9oADUTgrQAAABlJREFUCNdjYGRkZIBiJmSagQkEGDDEoRgABiAAN1Y85PAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/company-landing-page--register-path-2@2x.png
// module id = 169
// module chunks = 0